var exports = {
  "base": "xa15a2ab7--386d10--base",
  "small": "xa15a2ab7--386d10--small",
  "h1": "xa15a2ab7--386d10--h1",
  "h2": "xa15a2ab7--386d10--h2",
  "h3": "xa15a2ab7--386d10--h3",
  "huge": "xa15a2ab7--386d10--huge",
  "bold": "xa15a2ab7--386d10--bold",
  "black": "xa15a2ab7--386d10--black",
  "orange": "xa15a2ab7--386d10--orange",
  "blue": "xa15a2ab7--386d10--blue",
  "gray": "xa15a2ab7--386d10--gray",
  "white": "xa15a2ab7--386d10--white",
};

module.exports = exports;
